import { useSystemRequestSelectRegion } from './useSystemRequestSelectRegion';

export default useSystemRequestSelectRegion;
